// extracted by mini-css-extract-plugin
export default {"AnimatedAnnotationIcon":"AnnotationIcon-module__AnimatedAnnotationIcon__AQxe1st","fadeIn":"AnnotationIcon-module__fadeIn__Gt5XoZO"};